export function late(row) {
    let hours = hoursTardy(row);
    let rate_per_hour = row.hour_rate || 0;
    return hours * rate_per_hour;
}

export function grossPay(row) {
    const gross_pay = row.gross_pay || 0;
    const amount_overtime = row.amount_overtime || 0;
    const amount_night_diff = row.amount_night_diff || 0;
    const amount_special_holiday = row.amount_special_holiday || 0;
    const amount_legal_holiday = row.amount_legal_holiday || 0;
    const amount_rest_days = row.amount_rest_days || 0;
    return gross_pay - amount_overtime - amount_night_diff - amount_special_holiday - amount_legal_holiday - amount_rest_days;
}

export function totalPay(row) {
    //needs amount tardy computation, sil
    let lateDeduction = late(row);
    const gross_pay = row.gross_pay || 0;
    return gross_pay - lateDeduction;
}

export function totalContri(row) {
    const sss_contribution = row.sss_contribution || 0;
    const nhip_contribution = row.nhip_contribution || 0;
    const hdmf_contribution = row.hdmf_contribution || 0;
    return sss_contribution + nhip_contribution + hdmf_contribution;
}


export function hoursTardy(row) {
    //hours tardy is listed in minutes
    let minutes_tardy = row.hours_tardy || 0;

    return Number(minutes_tardy / 60).toFixed(2);
}

export function totalHours(row) {

    /*
    let total = summarizeFields(row, ['hours_work', 'overtime', 'special_holiday', 'legal_holiday', 'legal_holiday_overtime', 'rest_day_hours', 'rest_day_overtime']);
    let hours_tardy = hoursTardy(row);

    return total - hours_tardy;
    */

    return row.hours_work || 0;
}

export function totalDays(row) {
    /*
    let days_work = row.days_work || 0;
    let rest_days = row.rest_days || 0;
    let special_holiday_days = row.special_holiday_days || 0;
    let legal_holiday_days = row.legal_holiday_days || 0;


    let total = days_work + rest_days + special_holiday_days + legal_holiday_days;
    
    return total > 0 ? Math.ceil(total / 8) : 0;
    */

    return row.hours_work / 8 || 0;
}

export function summarizeFields(row = {}, fields = []) {
    let sum = fields.reduce((acc, currentField) => {
        let valueOfCurrentField = row?.[currentField] || 0
        return acc + valueOfCurrentField
    }, 0)

    return sum
}


export function grossBilling(entry) {
    let totalDeductions = Number(entry.total_deductions || 0)
    let total = Number(entry.total || 0)

    let grossBilling = total + totalDeductions

    return grossBilling
}

export function totalDeductions(entry) {
    let sss_contribution = Number(entry.sss_contribution || 0)
    let nhip_contribution = Number(entry.nhip_contribution || 0)
    let hdmf_contribution = Number(entry.hdmf_contribution || 0)
    let pagibig_calamity_loan = Number(entry.pagibig_calamity_loan || 0)

    let totalDeductions = sss_contribution + nhip_contribution + hdmf_contribution + pagibig_calamity_loan

    return totalDeductions
}

export function total(entry){
    let gross_pay = Number(entry.gross_pay || 0)
    let sil  = Number(entry.sil || 0)
    let amount_13th_month = Number(entry.amount_13th_month || 0)

    let total = gross_pay + sil + amount_13th_month

    return Number(total).toFixed(2)
}